var map = {
	"./change.svg": 74490,
	"./close.svg": 72146,
	"./copy.svg": 51653,
	"./disconnect.svg": 87500,
	"./explorer.svg": 17647,
	"./home.svg": 41103,
	"./icon-arrow.svg": 95361,
	"./icon-conversion.svg": 11722,
	"./icon-ok.svg": 63480,
	"./icon-search.svg": 36714,
	"./icon-share.svg": 33631,
	"./icon-time.svg": 93669,
	"./icon-up.svg": 27857,
	"./img-empty.svg": 98207,
	"./loading.svg": 84506,
	"./more.svg": 40241,
	"./mytokens.svg": 54114,
	"./ranking.svg": 29052,
	"./referral.svg": 73849,
	"./rewards.svg": 8526,
	"./setting.svg": 26114,
	"./telegram.svg": 39415,
	"./timeH5svg.svg": 39990,
	"./twitter.svg": 31655,
	"./txns.svg": 32555,
	"./zoom.svg": 4683,
	"./zoomOut.svg": 48809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;